<template>
  <v-app id="candora">
    <v-navigation-drawer
      v-model="drawer"
      app
      >
      <v-list dense>
        <template v-for="(item,index) in items">
          <v-list-item
            v-if="isAllowed(item.allowedRoles)"
            :key="index"
            router
            :to="item.link"
            >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
              {{ item.lable }}
              </v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      app
      class="primary"
      dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <router-link v-if="userIsAdmin" to="/allTracking" tag="span" style="cursor: pointer">
          Candora
        </router-link>
        <router-link v-if="!userIsAdmin" to="/myTracking" tag="span" style="cursor: pointer">
          Candora
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text router v-show="$vuetify.breakpoint.mdAndUp && this.userIsAuthenticated"  @click="onLogout">
        Abmelden
        <v-icon right>logout</v-icon>
      </v-btn>
      <v-btn icon router v-show="$vuetify.breakpoint.smAndDown && this.userIsAuthenticated"  @click="onLogout">
        <v-icon>logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-snackbar
    :value="showNotification"
    :top="true"
    :multi-line="true"
    :timeout=5000
    :color="notificationMessage.type">
      <div class=".title">{{notificationMessage.title}}</div>
      <v-btn
        icon
        dark
        text
        @click.native="closeNotification"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-content>
        <router-view></router-view>
        <data-loader></data-loader>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    drawer: null,
    items: [
      {icon: 'timer', lable: 'Zeit erfassen', link: '/myTracking', allowedRoles: ['USER']},
      {icon: 'timer', lable: 'Genehmigte Zeiten', link: '/myApprovedTracking', allowedRoles: ['USER']},
      {icon: 'timer', lable: 'Zeiten genehmigen', link: '/allTracking', allowedRoles: ['ADMIN']},
      {icon: 'group', lable: 'Kunden', link: '/customers', allowedRoles: ['ADMIN']},
      {icon: 'work', lable: 'Dienstleistungen', link: '/services', allowedRoles: ['ADMIN']},
      {icon: 'person_add', lable: 'Mitarbeiter', link: '/usermgmt', allowedRoles: ['ADMIN']},
      {icon: 'receipt', lable: 'Abrechnungen', link: '/invoices', allowedRoles: ['ADMIN']}
    ]
  }),
  computed: {
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    userIsAdmin () {
      if (this.userIsAuthenticated) {
        return this.$store.getters.user.role.toUpperCase() === 'ADMIN'
      }
    },
    showNotification: {
      get: function () {
        return this.$store.getters.showNotification
      },
      set: function (showNotification) {
        this.$store.dispatch('setShowNotification', showNotification)
      }
    },
    notificationMessage () {
      return this.$store.getters.notificationMessage
    }
  },
  methods: {
    isAllowed (roles) {
      if (this.$store.getters.user === null) return false
      return roles.includes(this.$store.getters.user.role)
    },
    closeNotification () {
      this.$store.commit('setShowNotification', false)
    },
    onLogout () {
      this.$store.dispatch('signUserOut')
        .then(() => location.reload())
    }
  }
}
</script>

<style>
  html { overflow-y: hidden !important }
</style>



// WEBPACK FOOTER //
// src/App.vue